import { post, url, defaultOptions } from "../index";

// Worker control endpoints. The /worker/* proxy is JWT + admin-gated on the
// app side; these helpers just hit it with the existing auth header.
// (api/index post() throws on !ok, which is what we want here.)

const ctrl = (path) => post(path, {}, false);

export const pauseQueue       = (name)        => ctrl(`/worker/api/queues/${encodeURIComponent(name)}/pause`);
export const resumeQueue      = (name)        => ctrl(`/worker/api/queues/${encodeURIComponent(name)}/resume`);
export const cleanQueue       = (name, status = "failed") =>
  ctrl(`/worker/api/queues/${encodeURIComponent(name)}/clean?status=${encodeURIComponent(status)}`);
// Company-scoped clean — the app proxy injects the caller's brandIds into
// the body, so we just need to declare the status here. SuperAdmin may
// also use this and the proxy passes brandIds through unchanged.
export const cleanQueueByBrand = (name, status = "failed") =>
  post(`/worker/api/queues/${encodeURIComponent(name)}/clean-by-brand`, { status }, false);
export const obliterateQueue  = (name)        => ctrl(`/worker/api/queues/${encodeURIComponent(name)}/obliterate`);

export const pauseScheduler   = (name)        => ctrl(`/worker/api/schedulers/${encodeURIComponent(name)}/pause`);
export const resumeScheduler  = (name)        => ctrl(`/worker/api/schedulers/${encodeURIComponent(name)}/resume`);
export const runSchedulerNow  = (name)        => ctrl(`/worker/api/schedulers/${encodeURIComponent(name)}/run-now`);
